var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.rowClass},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","id":_vm.id},domProps:{"checked":_vm.value},on:{"input":function($event){return _vm.handleCheckboxClicked($event)}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }